<template>
  <!-- エラーページ -->
  <div class="err">

    <p class="error-text" v-html="$t('500')" />

    <a href="/" class="button-top">
      <BtnBlue>
        <p class="txt" :class="[this.$route.params.lang]" v-html="$t('btn001')" />
      </BtnBlue>
    </a>
    <BtnOfficial />
  </div>
</template>

<script>
import BtnBlue from '@components/global/button-blue.vue'
import BtnOfficial from '@components/global/button-official.vue'

import localeError from '@locales/error'

export default {
  name: 'err',
  $messages: localeError,
  components: {
    BtnBlue,
    BtnOfficial
  },
}
</script>

<style lang="scss" scoped>
.error-text {
  width: 90%;
  margin: 60px auto 90px;
  font-size: 3rem;
  text-align: center;
  text-shadow: 0 3px 8px rgba(0, 0, 0, .6);
}

.button-top {
  display: block;
  margin: 40px 7.4%;
  /deep/ .button-inner {
    height: 100px;
  }
  .txt {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    @include hidden-text();
    background-repeat: no-repeat;
    background-position: center center;
    &.ja-JP {
      background-image: url(#{$img-path}err/ja-JP/txt_to-top.png);
    }
    &.de-DE {
      background-image: url(#{$img-path}err/de-DE/txt_to-top.png);
    }
    &.en-GB {
      background-image: url(#{$img-path}err/en-GB/txt_to-top.png);
    }
    &.en-US {
      background-image: url(#{$img-path}err/en-US/txt_to-top.png);
    }
    &.es-ES {
      background-image: url(#{$img-path}err/es-ES/txt_to-top.png);
    }
    &.es-MX {
      background-image: url(#{$img-path}err/es-MX/txt_to-top.png);
    }
    &.fr-CA {
      background-image: url(#{$img-path}err/fr-CA/txt_to-top.png);
    }
    &.fr-FR {
      background-image: url(#{$img-path}err/fr-FR/txt_to-top.png);
    }
    &.it-IT {
      background-image: url(#{$img-path}err/it-IT/txt_to-top.png);
    }
    &.pt-BR {
      background-image: url(#{$img-path}err/pt-BR/txt_to-top.png);
    }
    &.zh-TW {
      background-image: url(#{$img-path}err/zh-TW/txt_to-top.png);
    }
  }
}
</style>
